import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendFormDataRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { MediaPlaylistDto } from '@/types/dtos/media/media-playlist.dto.ts';
import { patchMediaPlaylistInQueryCache } from '@/state/mutations/media/patch-media-playlist-cache.ts';

export const useUploadVirtualMediaImageMutation = () => {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async ({ playlistId, slug, file }: { playlistId: string; slug: string; file: File }) => {
      const token = await getToken();
      return uploadVirtualMediaImage(playlistId, slug, file, token ?? '');
    },
    onSuccess: (updatedPlaylist) => {
      patchMediaPlaylistInQueryCache(queryClient, updatedPlaylist);
    },
  });
};

const uploadVirtualMediaImage = async (
  playlistId: string,
  slug: string,
  file: File,
  token: string,
): Promise<MediaPlaylistDto> => {
  const url = `${import.meta.env.VITE_API_URL}/media-playlists/${playlistId}/virtual-media/${encodeURIComponent(slug)}/image`;
  const formData = new FormData();
  formData.append('file', file);
  return sendFormDataRequest({ url, method: METHOD.PUT, body: formData, token });
};
